import { render, staticRenderFns } from "./IpsDropdown.vue?vue&type=template&id=417a08c3&scoped=true"
import script from "./IpsDropdown.vue?vue&type=script&lang=js"
export * from "./IpsDropdown.vue?vue&type=script&lang=js"
import style0 from "./IpsDropdown.vue?vue&type=style&index=0&id=417a08c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417a08c3",
  null
  
)

export default component.exports